// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__hbs5E","position":"Popup_position__ozT5G","popup":"Popup_popup__PugWK"};